/* ZSportsTech — section-clinic.js
   Animate gauge arcs (0 → arc) + sparkline draw on scroll-in.
   Resting state is FULLY VISIBLE; animation is progressive enhancement
   with a safety fallback so arcs never get stuck hidden.
   Vanilla JS only. Maps to → assets/section-clinic.js */
(function () {
  'use strict';

  function init() {
    var section = document.getElementById('sc-clinic');
    if (!section) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var arcs   = Array.prototype.slice.call(section.querySelectorAll('.sc-gauge__value'));
    var nums   = Array.prototype.slice.call(section.querySelectorAll('.sc-gauge__num'));
    var spark  = section.querySelector('.sc-clinic__sparkline-path');

    /* Reduced motion or no IO support → leave final (visible) state as-is */
    if (reduce || !('IntersectionObserver' in window)) return;

    /* Capture each arc's target, then collapse to 0 for the entrance */
    arcs.forEach(function (a) {
      var arc = parseFloat(a.dataset.arc) || 0;
      a.dataset.target = arc;
      a.style.strokeDasharray = '0 100';
    });
    if (spark) {
      var len = spark.getTotalLength ? spark.getTotalLength() : 200;
      spark.style.strokeDasharray = len;
      spark.style.strokeDashoffset = len;
      spark.style.transition = 'stroke-dashoffset 1.4s ease 0.3s';
    }

    var done = false;
    function reveal() {
      if (done) return;
      done = true;
      arcs.forEach(function (a) {
        a.style.strokeDasharray = (a.dataset.target || 0) + ' 100';
      });
      nums.forEach(function (n) {
        var target = parseInt(n.dataset.value || n.textContent, 10);
        if (!isNaN(target)) animateNum(n, target);
      });
      if (spark) spark.style.strokeDashoffset = '0';
    }

    function animateNum(el, target) {
      var start = null, dur = 1100;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = target;
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(); io.disconnect(); }
      });
    }, { threshold: 0.15 });
    io.observe(section);

    /* Safety net: if the observer hasn't fired within 4s but the section
       is on screen, reveal anyway so arcs are never stuck at 0. */
    setTimeout(function () {
      var r = section.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) reveal();
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
